module.exports = __webpack_public_path__ + "img/void-cart.34071400.png";